import html2pdf from 'html2pdf.js';

const exportPdf = (pdfEl, fileName = 'Yield Calculator Results') => {
  const pdfOptions = {
    filename: fileName,
    image: {
      type: 'png',
      quality: 1
    },
    html2canvas: {
      dpi: 192,
      letterRendering: true,
      scale: 2,
      useCORS: true
    },
    jsPDF: {
      format: 'a4',
      orientation: 'portrait'
    },
    margin: 0
  };

  const printableElementClone = pdfEl.cloneNode(true);
  printableElementClone.classList.add('pdf');

  // Choose the clonedElement and save the PDF for our user.
  html2pdf()
    .set(pdfOptions)
    .from(printableElementClone)
    .save();

  printableElementClone.remove();
}

export default exportPdf;
